import { createUseStyles } from 'react-jss'
import { THEME } from 'components/theme'

export const SecurityPinHostStyles = createUseStyles({
  scrim: {
    position: 'fixed',
    inset: 0,
    // Above drawers, sheets and the photo viewer: the PIN is always the top-most step
    zIndex: 100010,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    boxSizing: 'border-box'
  },
  card: {
    position: 'relative',
    backgroundColor: THEME.brandWhite,
    borderRadius: 16,
    width: 380,
    maxWidth: 'calc(100vw - 48px)',
    padding: '28px 24px 24px',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    gap: 12
  },
  close: {
    position: 'absolute',
    top: 12,
    right: 12,
    width: 32,
    height: 32,
    borderRadius: '50%',
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fill: THEME.brandMediumGrey
    },
    '&:hover': {
      backgroundColor: THEME.brandGrey
    }
  },
  lock: {
    width: 56,
    height: 56,
    borderRadius: '50%',
    backgroundColor: THEME.brandLightGreen,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      fill: THEME.brandGreen
    }
  },
  title: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    color: THEME.brandBlack
  },
  subtitle: {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.45,
    color: THEME.brandMediumGrey
  },
  // One real input (so typing, paste and backspace just work) drawn as spaced digits
  code: {
    width: '100%',
    maxWidth: 260,
    margin: '8px 0 0',
    padding: '10px 0 10px 0.6em',
    boxSizing: 'border-box',
    border: 'none',
    borderBottom: `2px solid ${THEME.brandGreen}`,
    borderRadius: 0,
    outline: 'none',
    background: 'transparent',
    textAlign: 'center',
    fontSize: 28,
    fontWeight: 700,
    letterSpacing: '0.6em',
    color: THEME.brandBlack,
    fontFamily: 'inherit',
    '&:disabled': {
      opacity: 0.5
    }
  },
  // Dots instead of digits without type="password" (no "save password?" prompt)
  masked: {
    '-webkit-text-security': 'disc'
  },
  codeError: {
    borderBottomColor: THEME.brandRed
  },
  error: {
    margin: 0,
    minHeight: 18,
    fontSize: 13,
    color: THEME.brandRed
  },
  link: {
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    padding: '6px 8px',
    fontSize: 14,
    fontWeight: 600,
    color: THEME.brandGreen,
    fontFamily: 'inherit',
    '&:disabled': {
      cursor: 'default',
      color: THEME.brandMediumGrey
    }
  },
  buttons: {
    display: 'flex',
    gap: 12,
    width: '100%',
    marginTop: 8
  },
  secondary: {
    flex: 1,
    height: 44,
    borderRadius: 22,
    border: `1px solid ${THEME.brandGreen}`,
    background: 'transparent',
    color: THEME.brandGreen,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit'
  },
  primary: {
    flex: 1,
    height: 44,
    borderRadius: 22,
    border: 'none',
    backgroundColor: THEME.brandGreen,
    color: THEME.onBrand,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
    fontFamily: 'inherit'
  },
  '@keyframes securityPinSpin': {
    to: { transform: 'rotate(360deg)' }
  },
  spinner: {
    width: 28,
    height: 28,
    margin: '12px 0',
    borderRadius: '50%',
    border: `3px solid ${THEME.brandLightGrey}`,
    borderTopColor: THEME.brandGreen,
    animation: '$securityPinSpin 0.8s linear infinite'
  }
})
